import React from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import PropTypes from 'prop-types';

function Tooltip({ content, children }) {
    return (
        <Tippy content={content}>
            <div>{children}</div>
        </Tippy>
    );
}

export default Tooltip;

Tooltip.propTypes = {
    content: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};
